import React from 'react'

import { MessageType } from '@app/graphql/types'
import { Customer, Message as CustomerMessageType } from '@app/queries/CustomerAsLawyer/models'

import { Answer } from '../Answer/Answer'
import { Question } from '../Question/Question'

// TODO: Localize this style to the relevant components
import './styles.scss'

export type ITopicQuestionnaireAnswers = Record<string, string>

type Props = {
  customer: Customer
  message: CustomerMessageType
  /** Tells whether the last message in the conversation is a Question */
  isLastMessageQuestion: boolean
  /** Tells whether this message is the last question */
  isLatestQuestion: boolean
}

export const Message = (props: Props) =>
  props.message.type === MessageType.Question ? <Question {...props} /> : <Answer {...props} />
